// extracted by mini-css-extract-plugin
export default {"option":"SaveCategoryModal_option__2YwCg","optionColor":"SaveCategoryModal_optionColor__Scf1S"};